/**
 * True when hostname is an AWS S3 endpoint (virtual-hosted or path-style).
 * Does not allow other *.amazonaws.com services or CloudFront aliases.
 */
export function isAwsS3Hostname(hostname) {
  if (!hostname || typeof hostname !== 'string') return false;

  const host = hostname.toLowerCase();

  return (
    /^(.+\.)?s3\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3-[a-z0-9-]+\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3\.[a-z0-9-]+\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3\.dualstack\.[a-z0-9-]+\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3-accelerate\.amazonaws\.com$/.test(host) ||
    /^(.+\.)?s3-accelerate\.dualstack\.amazonaws\.com$/.test(host)
  );
}

/**
 * True when the URL is same-origin as the current page (e.g. Vite-bundled assets).
 * Allows http/https only; used for local static PDFs under src/assets.
 */
export function isSameOriginPreviewUrl(parsed) {
  if (typeof window === 'undefined' || !window.location) return false;
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') return false;
  return parsed.origin === window.location.origin;
}

/**
 * Returns true when a document preview URL is safe to load in an iframe.
 * Allows https S3 URLs and same-origin asset URLs without embedded credentials;
 * blocks executable schemes.
 */
export function isSafeDocumentPreviewUrl(url) {
  if (!url || typeof url !== 'string') return false;

  try {
    const trimmed = url.trim();
    const parsed =
      typeof window !== 'undefined'
        ? new URL(trimmed, window.location.origin)
        : new URL(trimmed);

    if (parsed.username || parsed.password) return false;

    if (isSameOriginPreviewUrl(parsed)) return true;

    if (parsed.protocol !== 'https:') return false;
    return isAwsS3Hostname(parsed.hostname);
  } catch {
    return false;
  }
}
